import {useState, useEffect, useRef} from "react"

import {MC} from "./MC.js"

const feedbackBus = {listener: null}

function Feedbacks(props) {

  const [feedbacks, setFeedbacks] = useState(props.feedbacks || [])
  const timers = useRef(new Map())

  useEffect(() => {
    if (props.position === 'overlay') { // not overlay feedbacks do not subscribe to bus
      feedbackBus.listener = (feedback => {
        setFeedbacks(f => [...f, feedback])
      })
    }
    return () => {
      // cleanup all timers on unmount
      timers.current.forEach(clearTimeout)
      timers.current.clear()
    }
  }, [])

   useEffect(() => {
    for (const feedback of feedbacks) {
      if (MC.isNumeric(feedback.duration) && feedback.duration >= 0 && !timers.current.has(feedback.uuid)) {
        // auto-remove after duration
        const timeoutId = setTimeout(() => {
          setFeedbacks(f =>
            f.filter(item => item.uuid !== feedback.uuid)
          )
          timers.current.delete(feedback.uuid)
        }, feedback.duration * 1000)
        timers.current.set(feedback.uuid, timeoutId)
      }
    }  
  }, [feedbacks])

  function closeFeedback(uuid) {
    setFeedbacks(f =>
      f.filter(item => item.uuid !== uuid)
    )
  }

  let feedbacksRendered = []
  if (Array.isArray(feedbacks) && feedbacks.length > 0) {
    for (const feedback of feedbacks) {
      let color = ''
      let icon = 'info circle'
      switch (feedback.level) {
        case 'error': color = 'red'; icon = 'exclamation circle'; break;
        case 'warning': color = 'yellow'; icon = 'exclamation triangle'; break;
        case 'success': color = 'green'; icon = 'check circle'; break;
      }
      let help = MC.isNullOrEmpty(feedback.help) ? null : <p>{feedback.help}</p>
      let feedbackHtml = (
        <div className={MC.classes('mnc', color, 'icon message', feedback.class, 'feedback', feedback.level)} key={feedback.uuid}>
          <i className="close icon" onClick={closeFeedback.bind(this, feedback.uuid)}></i>
          <i className={MC.classes(icon, 'icon')}></i>
          <div className="content">
            <div className="header">{feedback.title}</div>
            {help}
          </div>
        </div>
      )
      feedbacksRendered.push(feedbackHtml)
    }
    feedbacksRendered = <div className={MC.classes('mnc feedbacks', {'overlayed': props.position === 'overlay'})}>{feedbacksRendered}</div>
  }
  return (feedbacksRendered)
}

export {Feedbacks, feedbackBus}